import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bot-paused-banner" }
const _hoisted_2 = { class: "bot-paused-banner__content" }


export default /*@__PURE__*/_defineComponent({
  __name: 'BotPausedBanner',
  emits: ["resume"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", null, "Conversation is with a human", -1)),
      _createVNode(_component_n_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('resume'))),
        variant: "primary"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Resume Bot")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})